export default {
  computed: {
    buttonText () {
      if (!this.available) {
        return 'Σύντομα κοντά σας'
      }

      if (this.progress) {
        return 'Προσθήκη...'
      }

      if (!this.onlineStatus) {
        return '<i class="icon-energy icons"></i>Εκτός Δικτύου'
      }

      return 'ΣΤΟ ΚΑΛΑΘΙ'
    },
    disabled () {
      return this.quantity < 1 || !this.onlineStatus || !this.available || this.progress
    },
    available () {
      return this.stock > 0 && !this.unavailable
    }
  }
}
